import { createAction, props } from '@ngrx/store';
import { HyundaiMenuNgrxEntity } from './hyundai-menu-ngrx.models';

export const init = createAction('[HyundaiMenuNgrx Page] Init');

export const loadHyundaiMenuNgrxSuccess = createAction(
  '[HyundaiMenuNgrx/API] Load HyundaiMenuNgrx Success',
  props<{ hyundaiMenuNgrx: HyundaiMenuNgrxEntity[] }>()
);

export const loadHyundaiMenuNgrxFailure = createAction(
  '[HyundaiMenuNgrx/API] Load HyundaiMenuNgrx Failure',
  props<{ error: any }>()
);

export const updateServicesForHyundaiMenu = createAction(
  '[HyundaiMenu] Update Hyundai Accepted and Declined Services',
  props<{
    acceptedServices: any[];
    declinedServices: any[];
  }>()
);

export const acceptServiceForHyundaiMenu = createAction(
  '[HyundaiMenu] Accept Service on Hyundai Menu',
  props<{
    acceptedService: any;
  }>()
);

export const removeAcceptedServiceFromHyundaiMenu = createAction(
  '[HyundaiMenu] Remove Accepted Service on Hyundai Menu',
  props<{
    acceptedService: string;
  }>()
);

export const declineServiceForHyundaiMenu = createAction(
  '[HyundaiMenu] Decline Service on Hyundai Menu',
  props<{
    declinedService: string;
  }>()
);

export const removeDeclinedServiceFromHyundaiMenu = createAction(
  '[HyundaiMenu] Remove Declined Service on Hyundai Menu',
  props<{
    declinedService: string;
  }>()
);
